import { SwapDialog } from '../SwapDialog/SwapDialog';
import { DefaultContent } from './components/DefaultContent';
import { useBondingTradeDialog } from './useBondingTradeDialog';

export const BondingTradeDialog = () => {
  const isOpen = useBondingTradeDialog((s) => s.isOpen);
  const close = useBondingTradeDialog((s) => s.close);
  const closable = useBondingTradeDialog((s) => s.closable);

  return (
    <SwapDialog isOpen={isOpen} close={close} closable={closable}>
      <DefaultContent />
    </SwapDialog>
  );
};
